module.exports = __webpack_public_path__ + "static/ch3-SCENE-02-MLKs_Voting_Rights_Act_vs_LBJs_Great_Society-865757e69f97d56a66a4b688ca729944.mp4";